import { css } from "@emotion/react";
import { kitText } from "../../styles";

export const styles = {
  base: css`
    ${kitText.variant.body}
    *:last-child {
      margin-bottom: 0;
    }

    h1 {
      font-size: 1.5rem;
    }
    h2 {
      font-size: 1.25rem;
    }
    h3 {
      font-size: 1rem;
    }
    table {
      border-collapse: collapse;
    }
    th,
    td {
      border-bottom: 1px solid var(--color-border-primary);
      padding: 0 var(--spacing-8);
    }
    td {
      border-color: var(--color-border-secondary);
    }
    th:first-of-type,
    td:first-of-type {
      padding-left: 0;
    }
    th:last-of-type,
    td:last-of-type {
      padding-right: 0;
    }
    ul,
    ol {
      margin-bottom: 0.25rem;
    }
    ol {
      padding-left: 0.75rem;
      li {
        padding-left: 0.25rem;
      }
    }
    ul {
      padding-left: 1rem;
      margin-top: 0;
      margin-bottom: 0.25rem;
    }
    blockquote {
      border-left: 2px solid var(--color-border-secondary);
      margin: var(--spacing-12) 0;
      padding: var(--spacing-4) var(--spacing-8);
      font-style: italic;
    }
    code {
      ${kitText.style.monospace}
      color: var(--color-secondary);
      background-color: var(--color-background-tertiary);
      padding: 0 var(--spacing-4);
      border-radius: var(--spacing-4);
    }
  `
};
